import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const accessFound: CaseReducer<NinchatState> = (state) => state
